import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';
import {
  LucideAngularModule,
  Mic,
  Radio,
  Camera,
  LayoutDashboard,
  Monitor,
  Sun,
  HardDriveDownload,
  ChevronRightIcon,
  ChevronLeftIcon,
  DrumstickIcon,
  FileIcon,
  PaletteIcon,
  LayoutIcon,
  Volume2Icon,
  MicIcon,
  SettingsIcon,
  CpuIcon,
  Drone,
  Music
} from 'lucide-angular';


@Component({
  selector: 'app-home-three',
  templateUrl: './home-three.component.html',
  styleUrl: './home-three.component.css'
})
export class HomeThreeComponent {
  readonly FileIcon = FileIcon;
  readonly PaletteIcon = PaletteIcon;
  readonly LayoutIcon = LayoutIcon;
  readonly Volume2Icon = Volume2Icon;
  readonly MicIcon = MicIcon;
  readonly SettingsIcon = SettingsIcon;
  readonly CpuIcon = CpuIcon;
  readonly DrumstickIcon = DrumstickIcon;
  readonly ChevronLeftIcon = ChevronLeftIcon;
  readonly ChevronRightIcon = ChevronRightIcon;
  readonly Broadcast = Radio;
  readonly CameraVideo = Camera;
  readonly LayoutDashboard = LayoutDashboard;
  readonly Monitor = Monitor;
  readonly Sun = Sun;
  readonly HardDriveDownload = HardDriveDownload;
  readonly Mic = MicIcon;  // alias, se quiser
  readonly music = Music;  // alias, se quiser


  
readonly DroneIcon = Drone;
      studioAImages: string[] = [
    'assets/images/podcast1.png',
    'assets/images/podcast2.png',
    'assets/images/podcast3.png',
    'assets/images/podcast2.png',
  ];

    studioBImages: string[] = [
    'assets/images/musica.png',
    'assets/images/musica2.png',
    'assets/images/musica3.png',
    'assets/images/musica.png',
  ];
    studioCImages: string[] = [
    'assets/images/mix1.png',
    'assets/images/mix2.png',
    'assets/images/mix3.png',
    'assets/images/mix4.png',
  ];


   private autoPlayIntervalA: any;
   private autoPlayIntervalC: any;

  currentImageIndexStudioA: number = 0;
    currentImageIndexStudioC: number = 0;

  currentImageStudioA: string = this.studioAImages[this.currentImageIndexStudioA];
  currentImageStudioC: string = this.studioCImages[this.currentImageIndexStudioC];

  // --- LÓGICA PARA O CARROSSEL DO ESTÚDIO B (MULTIUSO) ---
  private autoPlayIntervalB: any;
  
  currentImageIndexStudioB: number = 0;
  currentImageStudioB: string = this.studioBImages[this.currentImageIndexStudioB];
  // Propriedade para guardar a imagem atual e o seu índice

  // Video Player
  isMuted: boolean = true; // Start with the video muted

  toggleMute(): void {
    this.isMuted = !this.isMuted;
  }

  // Our Process
  steps = [
    {
      icon:"icon-tools secondary-color font-30px",
      title:"Design",
      desc:"Lorem ipsum dolor sit amet consectetur adipiscing elit. Proin ut tempor nisl sit amet tincidunt orci."
    },
    {
      icon:"icon-globe secondary-color font-30px",
      title:"Development",
      desc:"Lorem ipsum dolor sit amet consectetur adipiscing elit. Proin ut tempor nisl sit amet tincidunt orci."
    },
    {
      icon:"icon-mobile secondary-color font-30px",
      title:"Testing",
      desc:"Lorem ipsum dolor sit amet consectetur adipiscing elit. Proin ut tempor nisl sit amet tincidunt orci."
    },
    {
      icon:"icon-browser secondary-color font-30px",
      title:"Live",
      desc:"Lorem ipsum dolor sit amet consectetur adipiscing elit. Proin ut tempor nisl sit amet tincidunt orci."
    },
  ]
email = 'contato@elreylabs.com';
  @ViewChild('bgVideo') bgVideoRef!: ElementRef<HTMLVideoElement>;

  // Type it
  phrases: string[] = [ 'Inspirações', 'Arte', 'Experiências','Conteúdo digital'];
  displayedText: string = ''; 
  currentPhraseIndex: number = 0; 
  currentIndex: number = 0; 
  typingSpeed: number = 100; 
  delayBetweenPhrases: number = 1500; 
 // Função para ir para a imagem seguinte



ngAfterViewInit(): void {
    const video = this.bgVideoRef.nativeElement;
    video.muted = true;
    video.playsInline = true;

    // Tentar garantir autoplay em todos navegadores
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        console.warn('Autoplay falhou:', error);
      });
    }
  }
  
  ngOnInit(): void {
    this.startTyping();
   this.startAutoPlayA();
    this.startAutoPlayB();    
    this.startAutoPlayC();

  }
  

  startTyping(): void {
    this.typePhrase();
  }

  typePhrase(): void {
    const phrase = this.phrases[this.currentPhraseIndex];

    const typingInterval = setInterval(() => {
      if (this.currentIndex < phrase.length) {
        this.displayedText += phrase.charAt(this.currentIndex);
        this.currentIndex++;
      } else {
        clearInterval(typingInterval);
        setTimeout(() => {
          this.startDeleting();
        }, this.delayBetweenPhrases); // Delay before starting to delete
      }
    }, this.typingSpeed);
  }

  startDeleting(): void {
    const deletingInterval = setInterval(() => {
      if (this.currentIndex > 0) {
        this.displayedText = this.displayedText.slice(0, -1);
        this.currentIndex--;
      } else {
        clearInterval(deletingInterval);
        this.currentPhraseIndex = (this.currentPhraseIndex + 1) % this.phrases.length;
        this.currentIndex = 0;
        setTimeout(() => {
          this.typePhrase();
        }, this.delayBetweenPhrases); // Delay before starting to type the next phrase
      }
    }, this.typingSpeed / 2); // Faster deleting speed
  }

  // Team
  
  slideStoreTwo: { title: string; subtitle: string; image: string; index: number }[] = [
    {
      title: "Diretor de Marketing",
      subtitle: "Murilo Borborema",
      image: "team-1.jpg",
      index: 0
    },
    {
      title: "Roteirista e Direção de fotografia",
      subtitle: "Mércio Mota",
      image: "team-2.jpg",
      index: 1
    },
    {
      title: "Editora|Videomaker",
      subtitle: "Dani Oliveira",
      image: "team-3.jpg",
      index: 2
    },
    {
      title: "Produtor e técnico de Áudio",
      subtitle: "Juãozynho PJ",
      image: "team-4.jpg",
      index: 3
    }
  ];

  socialLinks = [
    { iconOuter: "facebook", iconInner: ['icofont icofont-social-facebook'] },
    { iconOuter: "twitter", iconInner: ['icofont icofont-social-twitter'] },
    { iconOuter: "pinterest", iconInner: ['icofont icofont-social-pinterest'] },
  ];

  // Services
  services = [
    {
      icon: "icon-tools font-30px white-color",
      title: "Branding",
      desc: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.",
    },
    {
      icon: "icon-linegraph font-30px white-color",
      title: "Marketing",
      desc: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.",
    },
    {
      icon: "icon-globe font-30px white-color",
      title: "Development",
      desc: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.",
    },
    {
      icon: "icon-tools font-30px white-color",
      title: "Web Design",
      desc: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.",
    },
    {
      icon: "icon-beaker font-30px white-color",
      title: "Social Media",
      desc: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.",
    },
    {
      icon: "icon-layers font-30px white-color",
      title: "Research",
      desc: "Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt.",
    },
  ]


  // Services
// Services
services2 = [
  {
    icon: "fa-solid fa-microphone-lines font-30px white-color",
    title: "Produção de Podcasts",
    desc: "Do roteiro à publicação, oferecemos soluções completas para a produção de podcasts com qualidade profissional.",
  },
  {
    icon: "fa-solid fa-chalkboard-user font-30px white-color",
    title: "Gravação de Cursos",
    desc: "Especializados na gravação de cursos, garantimos alta qualidade em vídeos educativos e didáticos.",
  }
,  
  {
    icon: "fa-solid fa-music font-30px white-color",
    title: "Produção de Áudio",
    desc: "Serviços completos de produção de áudio, incluindo produção musical,  composição, arranjo gravação, edição e mixagem .",
  },
  {
    icon: "fa-solid fa-guitar font-30px white-color",
    title: "Captação de Áudio e Músicas",
    desc: "Oferecemos serviços completos de captação de áudio e músicas, incluindo gravação de áudio, captação de músicas, dublagem, edição, mixagem e masterização.",
  },
  {
    icon: "fa-solid fa-camera font-30px white-color",
    title: "Fotografia Profissional",
    desc: "Capturamos momentos com qualidade impecável, seja para eventos, produtos ou sessões fotográficas personalizadas.",
  },
  {
    icon: "fa-solid fa-clapperboard font-30px white-color",
    title: "Vídeos Publicitários",
    desc: "Criamos vídeos impactantes para fortalecer a presença da sua marca e atrair seu público-alvo.",
  }
];


  // Skills
  skills = [
    { name: 'HTML', level: 90 },
    { name: 'CSS', level: 80 },
    { name: 'JavaScript', level: 85 },
    { name: 'Angular', level: 75 },
    { name: 'TypeScript', level: 70 }
  ];

  isScrolled = false;

  @HostListener('window:scroll', [])
  onScroll(): void {
    const skillsSection = document.querySelector('.skill');
    
    // Add a null check for skillsSection
    if (skillsSection) {
      const position = skillsSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      // Check if the section is in view
      if (position < windowHeight) {
        this.isScrolled = true;
      }
    }
  }

  // Portfolio
  portfolios = [
    {
      img: "1.JPG",
      title: "Pecê Cast ",
      subTitle: "Podcast"
    },
    {
      img: "2.jpg",
      title: "Upgrade Prevcast",
      subTitle: "Podcast"
    },
    {
      img: "3.jpg",
      title: "Rafa's Prevcast",
      subTitle: "Podcast"
    },
    {
      img: "4.jpg",
      title: "Conversão Podcast",
      subTitle: "Podcast"
    },
    {
      img: "5.jpg",
      title: "Altuz Podcast",
      subTitle: "Podcast"
    },
    {
      img: "6.jpg",
      title: "Nara Jorge",
      subTitle: "Web Clip"
    },
    {
      img: "7.jpg",
      title: "Dr. Amanda Rocha",
      subTitle: "Camapanha Médica"
    },
    {
      img: "8.jpg",
      title: "Wellen Kessy",
      subTitle: "Ep São João"
    }
  ]

  // Pricing
  pricing = [
    {
      title: "Basic Plan",
      subTitle: "An affordable option for end-to-end hiring at small companies.",
      currency: "$",
      amount: 9.99,
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Get Started",
      features: [
        'Mobile-Optimized Website',
        'Powerful Website Metrics',
        'Free Custom Domain',
        '24/7 Customer Support',
        'Fully Integrated E-Commerce',
        'Sell Unlimited Products &amp; Accept Donations',
        'No CMS items',
        'No site search',
        'No CMS API access',
        'No content editors'
      ]
    },

    {
      title: "Standard Plan",
      subTitle: "An affordable option for end-to-end hiring at small companies.",
      currency: "$",
      amount: 16.99,
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Get Started",
      features: [
        'Mobile-Optimized Website',
        'Powerful Website Metrics',
        'Free Custom Domain',
        '24/7 Customer Support',
        'Fully Integrated E-Commerce',
        'Sell Unlimited Products &amp; Accept Donations',
        'No CMS items',
        'No site search',
        'No CMS API access',
        'No content editors'
      ]
    },

    {
      title: "Extended Plan",
      subTitle: "An affordable option for end-to-end hiring at small companies.",
      currency: "$",
      amount: 24.99,
      btnClass: "btn btn-dark btn-md btn-default btn-square",
      btnText: "Get Started",
      features: [
        'Mobile-Optimized Website',
        'Powerful Website Metrics',
        'Free Custom Domain',
        '24/7 Customer Support',
        'Fully Integrated E-Commerce',
        'Sell Unlimited Products &amp; Accept Donations',
        'No CMS items',
        'No site search',
        'No CMS API access',
        'No content editors'
      ]
    }
  ];

  // Owl Testimonial
  customOptionsThree: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:true,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 3,
    navText: ['<i class="icofont icofont-arrow-left"></i>', '<i class="icofont icofont-arrow-right"></i>'],
    responsive:{
      0:{
          items:1,
      },
      600:{
          items:2,
      },
      1000:{
          items:3,
      }
    }
  }

  slideStoreThree = [
    {
      title: "Anne McAdams",
      subTitle: "CEO / Founder",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sodales nec nulla ac aliquet. Duis vel nunc eget.",
      image: "assets/images/team/avatar-1.jpg",
    },

    {
      title: "Jared Kane",
      subTitle: "CEO / Founder",
      description: "Quisque hendrerit turpis sit amet tortor condimentum, nec commodo lorem condimentum. Sed id diam efficitur, mattis tellus ac, malesuada purus. In ultrices nisl sed eleifend consequat.",
      image: "assets/images/team/avatar-2.jpg",
    },

    {
      title: "Nani Wale",
      subTitle: "CEO / Founder",
      description: "Quisque hendrerit turpis sit amet tortor condimentum, nec commodo lorem condimentum. Sed id diam efficitur, mattis tellus ac, malesuada purus. In ultrices nisl sed eleifend consequat.",
      image: "assets/images/team/avatar-3.jpg",
    },

    {
      title: "John Doe",
      subTitle: "CEO / Founder",
      description: "Quisque hendrerit turpis sit amet tortor condimentum, nec commodo lorem condimentum. Sed id diam efficitur, mattis tellus ac, malesuada purus. In ultrices nisl sed eleifend consequat.",
      image: "assets/images/team/avatar-4.jpg",
    }

  ]

  // Owl Brand Logos
  customOptionsFour: OwlOptions = {
    loop: true,
    dots: false,
    margin:0,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    responsive:{
      0:{
          items:1,
      },
      600:{
          items:2,
      },
      1000:{
          items:6,
      }
    }
  }

  slideStoreFour = [
    {
      image: "assets/images/clients/1.png",
    },

    {
      image: "assets/images/clients/2.png",
    },

    {
      image: "assets/images/clients/3.png",
    },

    {
      image: "assets/images/clients/4.png",
    },

    {
      image: "assets/images/clients/5.png",
    },

    {
      image: "assets/images/clients/6.png",
    }

  ]

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'contact-form';  // Replace with your EmailJS Service ID
  private templateId = 'contact-form-becki';  // Replace with your EmailJS Template ID
  private publicKey = 'gObMl0a3V0Jib9k5c';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }

  socialMedia = [
    {
      iconClass: "icon facebook",
      icon:"icofont icofont-social-facebook"
    },
    {
      iconClass: "icon twitter",
      icon:"icofont icofont-social-twitter"
    },
    {
      iconClass: "icon behance",
      icon:"icofont icofont-social-behance"
    },
    {
      iconClass: "icon linkedin",
      icon:"icofont icofont-social-linkedin"
    },
    {
      iconClass: "icon youtube",
      icon:"icofont icofont-social-youtube"
    },
    {
      iconClass: "icon instagram",
      icon:"icofont icofont-social-instagram"
    }
  ]

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  ngOnDestroy() {
    // Limpa os intervalos quando o componente é destruído para evitar memory leaks
    if (this.autoPlayIntervalA) {
      clearInterval(this.autoPlayIntervalA);
    }
    if (this.autoPlayIntervalB) {
      clearInterval(this.autoPlayIntervalB);
    }
  }


  
  startAutoPlayA(): void {
    this.autoPlayIntervalA = setInterval(() => {
      this.nextImageStudioA(true);
    }, 5000); // Muda a cada 5 segundos
  }

  resetAutoPlayA(): void {
    if (this.autoPlayIntervalA) {
      clearInterval(this.autoPlayIntervalA);
    }
    this.startAutoPlayA();
  }

  nextImageStudioA(isAutoPlay: boolean = false): void {
    this.currentImageIndexStudioA = (this.currentImageIndexStudioA + 1) % this.studioAImages.length;
    this.currentImageStudioA = this.studioAImages[this.currentImageIndexStudioA];
    if (!isAutoPlay) {
      this.resetAutoPlayA();
    }
  }

  prevImageStudioA(): void {
    this.currentImageIndexStudioA = (this.currentImageIndexStudioA - 1 + this.studioAImages.length) % this.studioAImages.length;
    this.currentImageStudioA = this.studioAImages[this.currentImageIndexStudioA];
    this.resetAutoPlayA();
  }

  goToSlideStudioA(index: number): void {
    this.currentImageIndexStudioA = index;
    this.currentImageStudioA = this.studioAImages[this.currentImageIndexStudioA];
    this.resetAutoPlayA();
  }

  // --- MÉTODOS PARA O CARROSSEL DO ESTÚDIO B ---

  startAutoPlayB(): void {
    this.autoPlayIntervalB = setInterval(() => {
      this.nextImageStudioB(true);
    }, 5500); // Intervalo ligeiramente diferente para não trocarem ao mesmo tempo
  }

  resetAutoPlayB(): void {
    if (this.autoPlayIntervalB) {
      clearInterval(this.autoPlayIntervalB);
    }
    this.startAutoPlayB();
  }

  nextImageStudioB(isAutoPlay: boolean = false): void {
    this.currentImageIndexStudioB = (this.currentImageIndexStudioB + 1) % this.studioBImages.length;
    this.currentImageStudioB = this.studioBImages[this.currentImageIndexStudioB];
    if (!isAutoPlay) {
      this.resetAutoPlayB();
    }
  }

  prevImageStudioB(): void {
    this.currentImageIndexStudioB = (this.currentImageIndexStudioB - 1 + this.studioBImages.length) % this.studioBImages.length;
    this.currentImageStudioB = this.studioBImages[this.currentImageIndexStudioB];
    this.resetAutoPlayB();
  }

  goToSlideStudioB(index: number): void {
    this.currentImageIndexStudioB = index;
    this.currentImageStudioB = this.studioBImages[this.currentImageIndexStudioB];
    this.resetAutoPlayB();
  }
//studioC

 startAutoPlayC(): void {
    this.autoPlayIntervalC = setInterval(() => {
      this.nextImageStudioC(true);
    }, 5000); // Muda a cada 5 segundos
  }

  resetAutoPlayC(): void {
    if (this.autoPlayIntervalC) {
      clearInterval(this.autoPlayIntervalC);
    }
    this.startAutoPlayC();
  }

  nextImageStudioC(isAutoPlay: boolean = false): void {
    this.currentImageIndexStudioC = (this.currentImageIndexStudioC + 1) % this.studioCImages.length;
    this.currentImageStudioC = this.studioCImages[this.currentImageIndexStudioC];
    if (!isAutoPlay) {
      this.resetAutoPlayC();
    }
  }

  prevImageStudioC(): void {
    this.currentImageIndexStudioC = (this.currentImageIndexStudioC - 1 + this.studioCImages.length) % this.studioCImages.length;
    this.currentImageStudioC = this.studioCImages[this.currentImageIndexStudioC];
    this.resetAutoPlayC();
  }

  goToSlideStudioC(index: number): void {
    this.currentImageIndexStudioC = index;
    this.currentImageStudioC = this.studioCImages[this.currentImageIndexStudioC];
    this.resetAutoPlayC();
  }

}


